// ! Warning: The DEBUG changes may cause issues with the production server.
const isDebugMode = import.meta.env.DEV;
export const DEBUG = isDebugMode;

const host = `${location.protocol}//${location.hostname}`;
let URLS = {
  FRONT: `${host}:9270`,
  BACK_DSH: `${location.origin}/api/dsh`,
};

if (DEBUG) {
  // for development
  URLS = {
    FRONT: `${host}:5173`,
    BACK_DSH: `${host}:7270/api/dsh`,
  };
}

export { URLS };

export const APIS = {
  checkStatus: '/authentication/check-status',
  accessMenu: '/program-navbar',
  userLanguage: '/common/authenticated-user/language-preference',
  language: '/common/authenticated-user/languages',
  updateLanguagePreference: '/users/language-preference',
  programLanguage: '/common/authenticated-user/programs',
  googleLogin: '/authentication/google',
  passwordLogin: '/authentication/login',
  otpRequest: '/authentication/otp/request',
  otpVerify: '/authentication/otp/verify',
  register: '/authentication/register',
  resetPassword: '/authentication/reset-password',
  logout: '/authentication/logout',
  //user
  usersList: (filterParams: string) => `/users?${filterParams}`,
  detailUser: (userID: string) => `/users/${userID}`,
  deleteUser: (userID: string) => `/users/${userID}`,
  createUser: '/users',
  updateUser: '/users/update',
  //code
  codeList: (filterParams: string) => `/codes?${filterParams}`,
  detailCode: (codeID: string) => `/codes/${codeID}`,
  createUpperCode: '/codes',
  createLowerCode: '/codes/lower',
  updateUpperCode: (codeID: string) => `/codes/${codeID}`,
  updateLowerCode: (codeID: string) => `/codes/lower/${codeID}`,
  deleteCode: (codeID: string) => `/codes/${codeID}`,
  //language management
  languageList: (filterParams: string) => `/languages?${filterParams}`,
  detailLanguage: (tag: string) => `/languages/${tag}`,
  createLanguage: '/languages',
  updateLanguage: (tag: string) => `/languages/${tag}`,
  deleteLanguage: (tag: string) => `/languages/${tag}`,
  initialAuthority: (filterParams: string) => `/authority/groups?${filterParams}`,
  programAuthenticated: (filterParams: string) =>
    `/programs/authenticated-user-language?${filterParams}`,
  upperProgram: '/programs/upper-programs',
  groupProgram: (groupCode: number) => `/authority/groups/${groupCode}/programs`,
  //program
  programList: (filterParams: string) => `/programs?${filterParams}`,
  detailProgram: (programID: string) => `/programs/${programID}`,
  createUpperProgram: '/programs',
  createLowerProgram: '/programs/lower',
  updateUpperProgram: (programID: string) => `/programs/${programID}`,
  updateLowerProgram: (programID: string) => `/programs/lower/${programID}`,
  deleteProgram: (programID: string) => `/programs/${programID}`,
  //authority
  initialAuthorityUser: (filterParams: string) => `/authority/groups/users?${filterParams}`,
  authorityUserAssignInfo: (groupCode: number) => `/authority/groups/${groupCode}/users`,
  authorityUserInfo: (groupCode: number) => `/authority/groups/${groupCode}`,
  createAuthority: '/authority/groups',
  forgotPassword: '/forgot-password',
  updateProfileByUser: '/users/update-user',
  updateProfilePassword: '/users/update-password',
  //Preference
  preference: '/common/system-preference',
  preferenceFile: '/common/system-preference/file',
  //storefront catalogue
  products: (filterParams: string) => `/products?${filterParams}`,
  productDetail: (slug: string) => `/products/${encodeURIComponent(slug)}`,
  //cart
  cart: '/cart',
  cartItems: '/cart/items',
  cartItem: (itemId: string) => `/cart/items/${encodeURIComponent(itemId)}`,
  //Edit Profil
  profile: '/profile',
  profilePhone: '/profile/phone',
  //address book
  addresses: '/addresses',
  address: (addressId: string) => `/addresses/${encodeURIComponent(addressId)}`,
  defaultAddress: (addressId: string) => `/addresses/${encodeURIComponent(addressId)}/default`,
  //shipping regions
  provinces: '/shipping/provinces',
  cities: (provinceId: string) => `/shipping/provinces/${encodeURIComponent(provinceId)}/cities`,
  districts: (cityId: string) => `/shipping/cities/${encodeURIComponent(cityId)}/districts`,
  subdistricts: (districtId: string) =>
    `/shipping/districts/${encodeURIComponent(districtId)}/subdistricts`,
  shippingRates: '/shipping/rates',
  //checkout (Bayar Sekarang)
  orderCheckout: '/orders/checkout',
  //purchase history (Riwayat Transaksi)
  orders: (filterParams: string) => `/orders?${filterParams}`,
  order: (orderId: string) => `/orders/${encodeURIComponent(orderId)}`,
  orderFinish: (orderId: string) => `/orders/${encodeURIComponent(orderId)}/finish`,
  orderCancel: (orderId: string) => `/orders/${encodeURIComponent(orderId)}/cancel`,
  //bank transfer payment (Pembayaran): Saya sudah transfer
  orderReportTransfer: (orderId: string) =>
    `/orders/${encodeURIComponent(orderId)}/report-transfer`,
  //Lacak Pengiriman
  orderTracking: (orderId: string) => `/orders/${encodeURIComponent(orderId)}/tracking`,
  //affiliate page (Family Members)
  affiliate: '/affiliate',
  payoutAccounts: '/affiliate/payout-accounts',
  affiliateWithdrawals: '/affiliate/withdrawals',
  //referral link visits (/ref/:code)
  referralClicks: '/referrals/clicks',
  //banks and e-wallets (Pilih Bank)
  banks: '/banks',
  storeAccounts: '/banks/store-accounts',
  //Book Donation Bulletin (Donasi)
  bookRequests: (filterParams: string) => `/book-requests?${filterParams}`,
  myBookRequests: (filterParams: string) => `/book-requests/mine?${filterParams}`,
  createBookRequest: '/book-requests',
  bookRequest: (postId: string) => `/book-requests/${encodeURIComponent(postId)}`,
  bookRequestLike: (postId: string) => `/book-requests/${encodeURIComponent(postId)}/like`,
  bookRequestComments: (postId: string, filterParams = '') =>
    `/book-requests/${encodeURIComponent(postId)}/comments${filterParams ? `?${filterParams}` : ''}`,
  bookRequestComment: (postId: string, commentId: string) =>
    `/book-requests/${encodeURIComponent(postId)}/comments/${encodeURIComponent(commentId)}`,
  bookRequestCommentLike: (postId: string, commentId: string) =>
    `/book-requests/${encodeURIComponent(postId)}/comments/${encodeURIComponent(commentId)}/like`,
  //Photo forum (Media (Foto Anak))
  kidsPosts: (filterParams: string) => `/kids-posts?${filterParams}`,
  myKidsPosts: (filterParams: string) => `/kids-posts/mine?${filterParams}`,
  createKidsPost: '/kids-posts',
  kidsPost: (postId: string) => `/kids-posts/${encodeURIComponent(postId)}`,
  kidsPostLike: (postId: string) => `/kids-posts/${encodeURIComponent(postId)}/like`,
  kidsPostComments: (postId: string, filterParams = '') =>
    `/kids-posts/${encodeURIComponent(postId)}/comments${filterParams ? `?${filterParams}` : ''}`,
  kidsPostComment: (postId: string, commentId: string) =>
    `/kids-posts/${encodeURIComponent(postId)}/comments/${encodeURIComponent(commentId)}`,
  kidsPostCommentLike: (postId: string, commentId: string) =>
    `/kids-posts/${encodeURIComponent(postId)}/comments/${encodeURIComponent(commentId)}/like`,
  //admin dashboard (Beranda)
  dashboardSummary: '/admin/dashboard/summary',
  dashboardLatestTransaction: '/admin/dashboard/latest-transaction',
  dashboardStockHighlights: (filterParams: string) =>
    `/admin/dashboard/stock-highlights?${filterParams}`,
  //admin orders (Riwayat Transaksi)
  adminOrders: (filterParams: string) => `/admin/orders?${filterParams}`,
  adminOrderSummary: '/admin/orders/summary',
  adminOrder: (orderId: string) => `/admin/orders/${encodeURIComponent(orderId)}`,
  adminOrderCancel: (orderId: string) => `/admin/orders/${encodeURIComponent(orderId)}/cancel`,
  adminOrderPickup: (orderId: string) =>
    `/admin/orders/${encodeURIComponent(orderId)}/request-pickup`,
  adminOrderConfirmPayment: (orderId: string) =>
    `/admin/orders/${encodeURIComponent(orderId)}/confirm-payment`,
  adminOrderRejectTransfer: (orderId: string) =>
    `/admin/orders/${encodeURIComponent(orderId)}/reject-transfer`,
  // Cetak Resi: the courier label PDF
  adminOrderLabel: (orderId: string) => `/admin/orders/${encodeURIComponent(orderId)}/label`,
  // Server-Sent Events: transfer_reported when a customer reports a bank transfer
  adminOrderEvents: '/admin/orders/events',
  //admin products (Pengaturan Produk)
  adminProducts: (filterParams: string) => `/admin/products?${filterParams}`,
  adminProductCreate: '/admin/products',
  adminProductSummary: '/admin/products/summary',
  adminProductCategories: '/admin/products/categories',
  adminProduct: (productId: string) => `/admin/products/${encodeURIComponent(productId)}`,
  adminProductImages: (productId: string) =>
    `/admin/products/${encodeURIComponent(productId)}/images`,
  adminProductImage: (productId: string, imageId: string) =>
    `/admin/products/${encodeURIComponent(productId)}/images/${encodeURIComponent(imageId)}`,
  //admin affiliates
  adminAffiliates: (filterParams: string) => `/admin/affiliates?${filterParams}`,
  adminAffiliateSummary: '/admin/affiliates/summary',
  adminAffiliate: (affiliateId: string) => `/admin/affiliates/${encodeURIComponent(affiliateId)}`,
  adminAffiliateWithdrawals: (affiliateId: string) =>
    `/admin/affiliates/${encodeURIComponent(affiliateId)}/withdrawals`,
  //admin refunds (Refund & Pengembalian)
  adminRefunds: (filterParams: string) => `/admin/refunds?${filterParams}`,
  adminRefundSummary: '/admin/refunds/summary',
  adminRefund: (requestId: string) => `/admin/refunds/${encodeURIComponent(requestId)}`,
  adminRefundAction: (
    requestId: string,
    action: 'approve' | 'reject' | 'confirm' | 'manual-transfer'
  ) => `/admin/refunds/${encodeURIComponent(requestId)}/${action}`,
};
